import { useAuth } from 'src/hooks/useAuth'
import APIService from 'src/services/APIService'



const OrgService = () => {
    const { currentUser, refreshUser } = useAuth()
    const { get, post, put, remove } = APIService()

    const getOrg = async () => {
        // if org already on user context
        if (currentUser.organization) {
            return currentUser.organization
        }

        let org: any

        await get('organizations/my-organizations', [])
            .then((resp: any) => {
                const _org = resp.pop()
                // save organization to user context
                refreshUser({ ...currentUser, organization: _org })
                org = _org
            })
        return org
    }

    const setOnboarded = async () => {
        const org = await getOrg()
        await put('organizations/' + org.id + '/set-onboarded' , [])
        .then((resp: any) => {
            let profile = {...currentUser.profile, onboarded_at: true }
            refreshUser({ ...currentUser, organization: resp, profile: profile })        
        })
    }

    const updateOrg = async (data: any) => {
        let newOrg: any

        await put('organizations/' + data.id , data)
            .then((resp: any) => {
                refreshUser({ ...currentUser, organization: resp })
            newOrg = {...resp}    
        })

        return newOrg
    }

    const getOrgGroups = async () => {
        let groups: any[] = []
        const org = currentUser.organization
        if (org) {
            await get('organizations/' + org.id + '/groups', [])
            .then((resp: any) => {
                groups = [...resp]
            })
        }
        
        return groups
    }

    const getOrgUsers = async () => {
        let users: any[] = []

        await get('organizations/my-org-users', [])
            .then((resp: any) => {
                users = [...resp]
            })
        return users
    }

    const getOrgServices = async () => {
        const org = currentUser.organization
        if (org) {
            let services: any[] = []

            await get('organizations/' + org.id + '/services', [])
                .then((resp: any) => {
                    services = [...resp]
                })
            return services
        }
        return []
    }

    const getOrgRoles = async () => {
        const org = currentUser.organization
        if (org) {
            let roles: any[] = []

            await get('organizations/' + org.id + '/roles', [])
                .then((resp: any) => {
                    roles = [...resp]
                })
            return roles.sort(function (a, b) {
                if (a.slug > b.slug) return 1;
                if (a.slug < b.slug) return -1;
                return 0;
            })
        }
        return []
    }

    const addOrgUser = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            let use: any
            await put('organizations/' + org.id + '/add-user', data)
                .then((resp: any) => {
                    use = resp
                })
            return use
        }
    }

    const addGroup = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            await put('organizations/' + org.id + '/add-group', data)
            .then((resp: any) => {  
            })
        }
    }

    const addRole = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            await put('organizations/' + org.id + '/add-role', data)
            .then((resp: any) => {  
            })
        }
    }

    const updateRole = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            await put('organizations/' + org.id + '/update-role', data)
            .then((resp: any) => {  
            })
        }
    }

    const updateGroup = async (gid: number, data: any) => {
        await put('groups/' + gid, data)
            .then((resp: any) => {  
            })
    }

    const activateOrg = async (id: number, status: boolean) => {
        await put('organizations/' + id + '/activate', { active: status })
    }


    const removeGroup = async (gid: number) => {
        await remove('groups/' + gid)
    }

    const removeService = async (sid: number) => {
        await remove('services/' + sid)
    }

    const removeRole = async (rid: number) => {
        await remove('roles/' + rid)
    }

    const addService = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            await put('organizations/' + org.id + '/add-service', data)
            .then((resp: any) => {  
            })
        }
    }

    const updateService = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            await put('organizations/' + org.id + '/update-service', data)
            .then((resp: any) => {  
            })
        }
    }

    const searchService = async (data: any) => {
        const org = currentUser.organization
        if (org) {
            let services: any[] = []
            await post('services/' + org.id + '/search', data)
            .then((resp: any) => {  
                services = [...resp]
            })
            return services
        }
        return []
    }


    const unlinkUser = async (oid: number, uid: number) => {

    }


    return {
        getOrg,
        updateOrg,
        activateOrg,
        getOrgUsers,
        addOrgUser,
        removeGroup,
        addGroup,
        updateGroup,
        getOrgServices,
        getOrgGroups,
        addService,
        removeService,
        updateService,
        getOrgRoles,
        addRole,
        updateRole,
        removeRole,
        searchService,
        setOnboarded
    }
}


export default OrgService 
